import Head from './../components/Head';
import Footer from './../components/Footer';
import Course from './components/Course';
import VirtualList from './components/virtualList';
import ResourceCenter from './components/ResourceCenter.vue';
import SpocCourse from './components/SpocCourse.vue';
import TeacherList from './components/TeacherList';
import BannerList from './components/BannerList';
import News from './components/News';
import TeacherData from './components/TeachData.vue';
import Link from '../components/aboutLink.vue';
import TeachingCenterList from './components/TeachingCenterList.vue';
import Lecture from './components/Lecture/index.vue';
export default {
  components: {
    Head,
    Course,
    TeacherList,
    BannerList,
    News,
    Footer,
    SpocCourse,
    TeacherData,
    Link,
    ResourceCenter,
    TeachingCenterList,
    Lecture,
    VirtualList
  },

  provide() {
    return {
      uuid: () => this.uuid,
      userId: () => this.userId
    };
  },

  created() {
    this.getDataList(); // this.getLive();
  },

  data() {
    return {
      menuCode: '10301',
      dataList: [],
      liveList: [],
      footerItem: null,
      dataItem: null,
      bannerItem: null,
      moocItem: null,
      spocItem: null,
      newsItem: null,
      teacherItem: null,
      teachingCenterItem: null,
      menuInfo: {},
      userInfo: null,
      zhsRole: 2,
      uuid: '',
      userId: '',
      lectureItem: null,
      navList: [],
      virtualItem: null
    };
  },

  methods: {
    getNavList(list) {
      this.navList = list;
      console.log(list, 'llll');
    },

    async getDataList() {
      const res = await this.$http.getDataList();
      console.log('首页数据', res);
      this.dataList = res;
      this.footerItem = this.dataList.find(item => item.function_id == '10303');
      this.dataItem = this.dataList.find(item => item.function_id == '10304');
      this.bannerItem = res.find(item => item.function_id == '10302');
      this.moocItem = res.find(item => item.function_id == '10401');
      this.spocItem = res.find(item => item.function_id == '10402');
      this.newsItem = res.find(item => item.function_id == '10701');
      this.teacherItem = res.find(item => item.function_id == '10501');
      this.teachingCenterItem = res.find(item => item.function_id == '51001');
      this.lectureItem = this.dataList.filter(item => item.function_id == '40005');
      this.virtualItem = this.dataList.find(item => item.function_id == '13200');
    },

    getUserInfo(data) {
      this.userInfo = data;
      this.uuid = data.uuid;
      this.userId = data.id;
    },

    getZhsRole(data) {
      this.zhsRole = data || 0; // console.log(this.zhsRole);
    }

  }
};